module.exports = __webpack_public_path__ + "static/media/logo-ana-sidebar-home.7c4dedb7.webp";